import {
  referralHistoryTableColumns,
  referralHistoryTableReferredByColumns,
  referralHistoryTableReferredToColumns,
} from '../../../constants/tableColumns';
import { useAuthContext } from '../../../contexts/AuthProvider';
import { useReferralHistoryContext } from '../../../contexts/ReferralHistoryProvider';
import { User } from '../../../types/users';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../../CommonComps/Tables/AcademiaTable';
import PageHeader from '../../CommonComps/Titles/PageHeader';
import ReferralHistoryFilterActions from './ReferralHistoryFilterActions';

const ShowAllReferralHistory = () => {
  // integration of context hooks here
  const { currentUser } = useAuthContext();
  const {
    isReferralHistoryLoading,
    isReferralHistoryFetching,
    referralHistoryType,
    referralHistoryList,
    associateReferralList: associateReferralByList,
  } = useReferralHistoryContext();

  console.log(
    'REFERRAL HISTORY LIST: ',
    referralHistoryList,
    isReferralHistoryFetching
  );

  // rendering show all referral history section component here
  return (
    <>
      {isReferralHistoryLoading ? (
        <AcademiaLoading />
      ) : (
        <section>
          <PageHeader headerText='Referral History' />

          <AcademiaTable
            data={
              (currentUser as User)?.role_name === 'Admin'
                ? referralHistoryList
                : associateReferralByList
            }
            columns={
              (currentUser as User)?.role_name === 'Admin'
                ? referralHistoryTableColumns
                : referralHistoryType === 'by'
                ? referralHistoryTableReferredByColumns
                : referralHistoryTableReferredToColumns
            }
            notFoundMessage='No referral history found!'
            tableToolbarComponent={
              (currentUser as User)?.role_name === 'Associate' ? (
                <ReferralHistoryFilterActions />
              ) : undefined
            }
            isTableDataLoading={isReferralHistoryFetching}
          />
        </section>
      )}
    </>
  );
};

export default ShowAllReferralHistory;
